import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Squash as Hamburger } from "hamburger-react";
import "./desknav.css";

function DesktopNav() {
  const [show, setShow] = useState(false);
  const [color, setColor] = useState("#4cb88f");

  useEffect(() => {
    if (show) {
      setColor("#0f0f0f");
    } else {
      setColor("#4cb88f");
    }
  }, [show]);

  const links = ["Home", "Our Process", "About Us", "Pricing", "Work"];
  const container = {
    hidden: { opacity: 0, delay: 1000 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.07,
      },
    },
  };

  const listItem = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  };

  function goToContact() {
    window.scrollTo(0, document.getElementById("contact").offsetTop);
  }

  function goToSection(section) {
    //console.log(section.target.innerHTML);
    const id = section.target.innerHTML.toLowerCase();

    window.scrollTo(0, document.getElementById(id).offsetTop);
    setShow(false);
  }
  return (
    <div className="main-wrapper" style={{ width: "100%", display: "flex" }}>
      <div
        className="home-left-navbar-section"
        style={{ justifyContent: "left" }}
      >
        <div className="hamburger-container">
          <Hamburger
            toggled={show}
            toggle={setShow}
            rounded
            color={color}
            className="close-btn"
          />
        </div>
        <AnimatePresence>
          {show && (
            <div className="side-wrapper">
              <div className="left-side" onClick={() => setShow(!show)}></div>
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: 400 }}
                exit={{ width: 0 }}
                className="sidebar-container"
              >
                <motion.div
                  variants={container}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="links-container"
                >
                  {links.map((item, i) => (
                    <motion.a
                      variants={listItem}
                      className="nav-link"
                      key={i}
                      onClick={(item) => goToSection(item)}
                    >
                      {item}
                    </motion.a>
                  ))}
                </motion.div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
        {/*<NavBar />*/}
      </div>
      <div className="home-left-navbar-section centerNavBar">
        <div className="logo_desktop"></div>
        <h1 className="home-left-navbar-title">
          adaptimise <br />
        </h1>
      </div>
      <div
        className="home-left-navbar-section hidecontact"
        style={{ justifyContent: "right" }}
      >
        <button onClick={goToContact} className="home-right-connect">
          Contact
        </button>
      </div>
    </div>
  );
}

export default DesktopNav;
